import tenantConstants from '@constants';
import tenantTheme from '@theme';
import React from 'react';
import styled from 'styled-components';
import { Button } from '../button/button';
import Group from '../group/group';
import Label from '../Label/Label';

// Bayut post-listing redesign (FORM config present) uses a filled teal dropzone per Figma.
const REDESIGN_FORM = !!tenantConstants?.FORM;

export const ImageUpload = styled(Group)`
  @media screen and (min-width: 992px) {
    border: 1px dashed ${REDESIGN_FORM ? '#DDEAEB' : tenantTheme['primary-light-1']};
    ${REDESIGN_FORM ? 'background: #F2FAFA;' : ''}
    border-radius: ${tenantTheme['border-radius-base']};
    font-size: 14px;
    padding: 24px;
  }
`;

// Bayut redesign: per-field icon sits in a 32x32 light-gray rounded box (Figma).
export const FieldIconBox = styled.div`
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: ${(props) => (props.$mobile ? '24px' : '32px')};
  height: ${(props) => (props.$mobile ? '24px' : '32px')};
  border-radius: ${(props) => (props.$mobile ? '50%' : '9.6px')};
  background: #f4f5f7;
  color: #707070;

  svg {
    width: ${(props) => (props.$mobile ? '14px' : '17px')};
    height: ${(props) => (props.$mobile ? '14px' : '17px')};
  }
`;

export const Thumbnail = styled.img`
  --thumbnail-width: 96px;
  --thumbnail-height: 96px;

  width: var(--thumbnail-width);
  height: var(--thumbnail-height);
  object-fit: cover;
  border-radius: var(--border-radius);
`;

export const Retry = styled.button`
  border: 0;
  background-color: hsla(0, 0%, 0%, 0.7);
  border-radius: 24px;
  color: #fff;
  cursor: pointer;
  font-size: 0.8em;
  padding: 4px 12px;
  z-index: 1;
`;

// export const SpinnerStyled = styled(Spinner)` `;

export const DocumentsThumb = styled.div`
  width: 100%;
  padding: 8px 16px;
  border: 1px dashed #009f2b;
  border-radius: 8px;

  .file-tile {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .file-icon {
      color: ${tenantTheme['gray-lightest-color']};
    }

    .btnTrash {
      border: 0;
      padding: 0;
      color: ${tenantTheme['error-color']};
    }
  }
`;

export const UploadButton = styled((props) => <Label {...props} />)`
  &,
  &:hover {
    height: initial;
    color: #fff;

    @media only screen and (max-width: 991px) {
      border: 1px dashed ${tenantTheme['primary-light-1']};
      color: ${tenantTheme['gray-dark-color']};
      background: none;
      text-shadow: none;
      box-shadow: none;
      min-width: 96px;
      width: 100%;
      white-space: normal;
      height: 96px;
      display: flex;
      flex-direction: column;
      place-content: center;
      gap: 4px;
      font-size: 12px;
      font-weight: 400;
    }
  }
`;

export const Remove = styled((props) => <Button {...props} />)``;

export const GalleryThumb = styled.div`
  width: 96px;
  height: 96px;
  position: relative;
  display: grid;
  place-items: center;
  overflow: hidden;
  cursor: pointer;

  > * {
    grid-area: 1 / 1;
  }

  > .btn {
    background-color: #f6f7f7;
    border: 1px solid #f1f2f2;
    border-radius: 4px;
    width: inherit;
    height: inherit;
    padding: 0;

    &:hover,
    &:focus {
      border-color: #ddd;
    }
  }

  ${Thumbnail} {
    filter: ${(props) => props.faded && `grayscale(0.8)`};
    opacity: ${(props) => props.faded && 0.8};
  }

  ${Remove} {
    position: absolute;
    inset-inline-end: 4px;
    inset-block-start: 4px;
  }

  /* Bayut redesign thumbnails: smaller 12px close glyph (Figma). */
  &.redesign-thumb ${Remove} svg {
    width: 12px;
    height: 12px;
  }

  /* Mobile thumbnails are smaller (84px) so the close control is scaled down to match. */
  &.redesign-thumb-mobile ${Remove} svg {
    width: 10px;
    height: 10px;
  }
`;

/* Bayut redesign: 6-dot drag affordance pinned top-left of each thumbnail. */
export const DragHandle = styled.div`
  position: absolute;
  inset-block-start: 6px;
  inset-inline-start: 6px;
  z-index: 2;
  line-height: 0;
  pointer-events: none;
`;

/* Bayut redesign: "Cover" chip pinned bottom-left (Figma). */
export const CoverChip = styled.span`
  position: absolute;
  inset-block-end: 6px;
  inset-inline-start: 6px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5.35px;
  width: ${(props) => (props.$mobile ? '44px' : '45px')};
  height: ${(props) => (props.$mobile ? '16px' : '17.7px')};
  padding: 2.86px 6px;
  border-radius: 16px;
  background: #f5f5f5;
  color: #4f4f4f;
  font-size: ${(props) => (props.$mobile ? '10px' : '12px')};
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
`;
